var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "40px",
    viewBox: "0 0 150 40",
    enableBackground: "new 0 0 150 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -15,
    y: -23.907,
    width: 180,
    height: 87.815
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#3772FF",
    d: "M13.547,14.703L13.547,14.703c-1.646,1.646-4.315,1.646-5.961,0L2.713,9.831 c-1.646-1.646-1.646-4.315,0-5.961c1.646-1.646,4.315-1.646,5.961,0l4.872,4.872C15.193,10.387,15.193,13.056,13.547,14.703"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#3772FF",
    d: "M29.63,24.306c0.286,0.121,0.588,0.21,0.901,0.268"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#3772FF",
    d: "M27.613,33.118c-0.075-0.022-0.152-0.041-0.227-0.064 C27.46,33.078,27.537,33.098,27.613,33.118"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#3772FF",
    d: "M21.057,11.853c-0.135,0.108-0.267,0.222-0.393,0.347L3.308,29.556 c-1.786,1.786-1.786,4.683,0,6.469c1.786,1.786,4.683,1.786,6.469,0l9.67-9.67c-0.92-1.809-1.441-3.854-1.441-6.022 C18.006,17.111,19.151,14.156,21.057,11.853"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#3772FF",
    d: "M27.133,12.2c-1.661-1.661-4.281-1.775-6.076-0.347 c-1.906,2.303-3.051,5.258-3.051,8.48c0,2.168,0.522,4.213,1.441,6.022l7.686-7.686C28.919,16.883,28.919,13.987,27.133,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#3772FF",
    d: "M27.133,12.2c-1.661-1.661-4.281-1.775-6.076-0.347 c-0.136,0.108-0.267,0.222-0.393,0.347L3.308,29.556c-1.786,1.786-1.786,4.683,0,6.469c1.786,1.786,4.683,1.786,6.469,0l9.67-9.67 l7.686-7.686C28.919,16.883,28.919,13.987,27.133,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#3772FF",
    d: "M31.316,7.023c-4.129,0-7.818,1.88-10.26,4.831 c1.796-1.428,4.415-1.314,6.076,0.347c1.576,1.576,1.76,4.016,0.553,5.796L27.69,18c0.768-1.191,2.103-1.981,3.626-1.981 c2.383,0,4.315,1.932,4.315,4.315c0,2.383-1.932,4.315-4.315,4.315c-0.269,0-0.53-0.028-0.785-0.075 c-0.313-0.058-0.548-0.187-0.901-0.268c-0.273-0.051-0.554-0.081-0.842-0.081c-2.5,0-4.527,2.027-4.527,4.527 c0,2.01,1.311,3.712,3.125,4.303c0.075,0.023,0.151,0.043,0.227,0.064c1.176,0.34,2.418,0.526,3.704,0.526 c7.351,0,13.311-5.959,13.311-13.311S38.668,7.023,31.316,7.023"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 44.1982 27.8204)",
    fill: "#3772FF",
    fontFamily: "'Poppins-Bold'",
    fontSize: 19.3924
  }, "ANAROMA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 119.211 37.6055)",
    fill: "#3772FF",
    fontFamily: "'AktivGroteskTrial-Bold'",
    fontSize: 9.3669
  }, "SWAP"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapLogo);
export default __webpack_public_path__ + "static/media/swap_logo.015273c9499b111feadb7305f94c5bdf.svg";
export { ForwardRef as ReactComponent };